export default __webpack_public_path__ + "static/zaru_collages_v6-6-9ad6bd226231b0e1edcffdc3ecabe255.png";